import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { Named } from '../base/named';
import { shellStringResources } from '../../Resources/ShellStringResources';

export const expressCustomSetupTypes = {
    Cmdkey: 'CmdkeySetup',
    SqlServerAlias: 'SqlServerAliasSetup',
    EnvVariable: 'EnvironmentVariableSetup',
    Installation: 'ComponentSetup',
    AzPowerShell: 'AzPowerShellSetup',
    Msdtc: 'MsdtcSetup'
};

@Metamodel.model({
    name: 'expressCustomSetup',
    display: [shellStringResources.ModelName_Extension, shellStringResources.ModelName_Extensions]
})
export abstract class ExpressCustomSetup extends Named {
    public static readonly MODEL: IModel;
    public customSetupType: string;

    constructor(customSetupType: string, name?: string, public description?: string) {
        super(name, description);
        this.customSetupType = customSetupType;
    }

    public abstract getCustomSetupName(): string;
    public abstract coincideWith(customSetup: ExpressCustomSetup): void;
    public abstract validate(): boolean;
}
